<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{ aLang.c_list }} {{ aLang.rf_title }}
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse
            v-bind:visible="mData.tableRules.showFormSearch"
            id="myFormSearch"
          >
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="4">
                    <el-form-item :label="aLang.rf_sender">
                      <!-- <el-select
                        v-model="mData.tableRules.dataSearch.value.nguoi_gui_id"
                        :disabled="mData.viewMode == 'detail'"
                        clearable
                        filterable
                        placeholder="Nhập từ khóa (nhấn enter để tìm kiếm)"
                        no-data-text="Chưa có dữ liệu"
                        :filter-method="fn_remoteGetListNguoiGui"
                        @keyup.enter.native="fn_findNguoiGui"
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listFindNguoiGui"
                          :key="item.id"
                          :label="item.ho_ten"
                          :value="item.nguoi_gui_id"
                        ></el-option>
                      </el-select> -->

                      <el-autocomplete
                        :disabled="mData.viewMode == 'detail'"
                        clearable
                        class="inline-input"
                        v-model="nguoiGui"
                        :fetch-suggestions="querySearchNguoiGui"
                        placeholder="Nhập từ khóa để tìm kiếm"
                        :trigger-on-focus="false"
                        @select="handleSelectNguoiGui"
                        @change="handleSelectNguoiGui"
                      >
                        <template slot-scope="{ item }">
                          <span class="link">{{ item.ho_ten }}</span>
                        </template>
                      </el-autocomplete>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item
                      :label="aLang.rf_reflection_day"
                      prop="thoi_diem_phan_hoi"
                    >
                      <el-date-picker
                        type="date"
                        :format="aElement.datepicker.formatDate"
                        :valueFormat="aElement.datepicker.valueFormat"
                        v-model="
                          mData.tableRules.dataSearch.value.thoi_diem_phan_hoi
                        "
                        :placeholder="aElement.datepicker.placeholderDate"
                        clearable
                      ></el-date-picker>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                    >{{ aLang.c_search }}</el-button
                  >
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col
            :class="
              aRole('TCQLTT') || aRole('Admin') ? 'col-md-10' : 'col-md-8'
            "
          >
            <div class="text-left mb-0">
              <b-row>
                <b-col md="3" v-show="aRole('Admin')">
                  <el-select
                    v-model="
                      mData.tableRules.dataSearch.value[
                        'doi_tuong_phan_hoi.doi_tuong'
                      ]
                    "
                    :placeholder="'Đối tượng ' + phanHoiText"
                    :disabled="mData.viewMode == 'detail'"
                    @change="fn_tableSearch()"
                    clearable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listDoiTuongPhanHoi"
                      :key="item.code"
                      :label="item.text"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </b-col>
                <!-- <b-col :class="aRole('TCQLTT') || aRole('Admin') ? 'col-md-3' : 'col-md-4'" v-if="!aRole('VNATAdmin')"> -->
                <!-- <el-select
                    v-model="mData.dataDefault.loai_nhom_phan_hoi"
                    :placeholder="'Loại nhóm ' + phanHoiText"
                    :disabled="mData.viewMode == 'detail'|| aRole('VNATAdmin')"
                    @change="fn_selectData(mData.dataDefault.loai_nhom_phan_hoi)"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listLoaiNhomPhanHoi"
                      :key="item.code"
                      :label="item.text"
                      :value="item.code"
                    ></el-option>
                  </el-select> -->

                <!-- <el-autocomplete
                    clearable
                    class="inline-input"
                    :disabled="mData.viewMode == 'detail'|| aRole('VNATAdmin')"
                    v-model="loai_nhom_phan_hoi"
                    :fetch-suggestions="querySearchLoaiNhomPhanHoi"
                    :placeholder="aLang.rf_reflection_group_type"
                    :trigger-on-focus="true"
                    @select="handleSelectLoaiNhomPhanHoi"
                    @change="handleSelectLoaiNhomPhanHoi"
                  >
                    <template slot-scope="{ item }">
                      <span class="link">{{ item.text }}</span>
                    </template>
                  </el-autocomplete>                   -->

                <!-- </b-col> -->
                <b-col :class="aRole('TCQLTT') ? 'col-md-5' : 'col-md-7'">
                  <!-- <el-select
                    v-model="mData.tableRules.dataSearch.value.nhom_phan_hoi"
                    :placeholder="'Nhóm ' + phanHoiText"
                    :disabled="mData.viewMode == 'detail'"
                    @change="fn_tableSearch()"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listNhomPhanHoi"
                      :key="item.id"
                      :label="item.ten.vi"
                      :value="item.id"
                    ></el-option>
                  </el-select> -->
                  <el-autocomplete
                    clearable
                    class="inline-input"
                    :disabled="mData.viewMode == 'detail'"
                    v-model="nhom_phan_hoi"
                    :fetch-suggestions="querySearchNhomPhanHoi"
                    :placeholder="aLang.rf_reflection_group"
                    :trigger-on-focus="true"
                    @select="handleSelectNhomPhanHoi"
                    @change="handleSelectNhomPhanHoi"
                  >
                    <template slot-scope="{ item }">
                      <span class="link">
                        {{ item.ten.vi }}
                      </span>
                    </template>
                  </el-autocomplete>
                </b-col>
                <b-col
                  :class="aRole('Admin') ? 'col-md-3' : 'col-md-3'"
                  v-if="!aRole('TCQLTT')"
                >
                  <el-select
                    v-model="mData.tableRules.dataSearch.value.trang_thai"
                    :placeholder="aLang.rf_status"
                    :disabled="mData.viewMode == 'detail'"
                    @change="fn_tableSearch()"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.trangThai"
                      :key="item.code"
                      :label="item.text"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                  <!-- <el-autocomplete
                    clearable
                    class="inline-input"
                    v-model="ten_xep_hang"
                    :fetch-suggestions="querySearchXepHang"
                    placeholder="Chọn"
                    :trigger-on-focus="true"
                    @select="handleSelectXepHang"
                    @change="handleSelectXepHang"
                  >
                    <template slot-scope="{ item }">
                      <span class="link">{{ item.ten.vi }}</span>
                    </template>
                  </el-autocomplete>                  -->
                </b-col>
                <b-col md="3" v-if="aRole('TCQLTT')">
                  <el-select
                    v-model="
                      mData.tableRules.dataSearch.value['tcqltt.trang_thai']
                    "
                    :placeholder="aLang.rf_status"
                    :disabled="mData.viewMode == 'detail'"
                    @change="fn_tableSearch()"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.trangThaiTcqltt"
                      :key="item.code"
                      :label="item.text"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </b-col>
                <b-col md="4" v-if="aRole('TCQLTT')">
                  <el-select
                    v-model="mData.dataDefault.dataNguoiXuLy"
                    :placeholder="aLang.rf_person_in_charge"
                    :disabled="mData.viewMode == 'detail'"
                    @change="fn_tableSearch()"
                    filterable
                    multiple
                    collapse-tags
                    no-data-text="Chưa có dữ liệu"
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listFindNguoiXuLy"
                      :key="item.id"
                      :label="item.ho_ten.ho_ten"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col
            :class="aRole('TCQLTT') || aRole('Admin') ? 'col-md-2' : 'col-md-4'"
          >
            <div class="text-right mb-2">
              <el-button
                @click="fn_SendTcqltt()"
                type="danger"
                plain
                :disabled="mData.dataDefault.countPhanHois <= 0"
                v-if="!aRole('TCQLTT') && !aRole('Admin')"
                >{{ aLang.c_sendTcqltt }}</el-button
              >
              <el-button @click="fn_tableShowFormSearch()" type="info" plain>{{
                aLang.c_showHideSearch
              }}</el-button>
              <!-- <el-button @click="fn_handle('create')" type="info" plain>{{aLang.c_create}}</el-button> -->
            </div>
          </b-col>
        </b-row>

        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          default-expand-all
          style="width: 100%"
          :default-sort="{
            prop: mData.tableRules.defaultSort[0],
            order: mData.tableRules.defaultSort[1],
          }"
        >
          <el-table-column
            type="selection"
            width="40"
            v-if="mData.tableRules.allowSelect"
          ></el-table-column>
          <el-table-column
            prop="selectedToSend"
            :label="aLang.rf_choose"
            width="60"
            align="center"
            v-if="!aRole('TCQLTT')"
          >
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.selectedToSend"
                @change="fn_changeSelectedToSend(scope.row.selectedToSend)"
                v-if="
                  scope.row.trang_thai !== 'forwarded_to_tcqltt' &&
                  scope.row.allowSend == true
                "
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            prop="ten_nguoi_gui"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.rf_sender"
            width="210"
          >
            <template slot-scope="scope">
              <el-link
                class="cell-child"
                target="_blank"
                @click="fn_handle('detail', scope.$index, scope.row)"
                :underline="false"
                >{{
                  scope.row.ten_nguoi_gui && scope.row.ten_nguoi_gui.trim()
                    ? scope.row.ten_nguoi_gui
                    : "Chưa cập nhật thông tin"
                }}</el-link
              >
              <p class="m-0 p-0 text-primary">
                {{
                  scope.row.tcqltt && scope.row.tcqltt.nguoi_xu_ly_id
                    ? scope.row.tcqltt.ten_nguoi_xu_ly
                    : ""
                }}
              </p>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="dien_thoai"
            :sortable="mData.tableRules.allowSorting"
            label="Số điện thoại"
            width="120"
            v-if="!aRole('TCQLTT')"
          ></el-table-column>-->
          <el-table-column
            prop="ten_nhom_phan_hoi"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.rf_reflection_group"
            width="220"
          >
            <template slot-scope="scope">
              <span>
                {{ scope.row.ten_nhom_phan_hoi }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="doi_tuong_nhan.doi_tuong"
            label="Đối tượng nhận"
            width="180"
          >
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.doi_tuong_nhan && scope.row.doi_tuong_nhan.doi_tuong
                "
              >
                <span
                  :class="`doi-tuong doi-tuong__${scope.row.doi_tuong_nhan.doi_tuong}`"
                >
                  {{
                    scope.row.doi_tuong_nhan.doi_tuong === "CQQL"
                      ? "Cơ quan quản lý"
                      : scope.row.doi_tuong_nhan.doi_tuong === "DNLH"
                      ? "Doanh nghiệp lữ hành"
                      : scope.row.doi_tuong_nhan.doi_tuong === "DDAT"
                      ? "Điểm đến an toàn"
                      : "Chưa có thông tin"
                  }}
                </span>
              </span>
              <span v-else>Không có đối tượng</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="noi_dung"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.rf_content"
            width="auto"
            min-width="150"
          >
            <template slot-scope="scope">
              <p class="m-0 p-0">{{ scope.row.noi_dung }}</p>
              <p class="m-0 p-0 text-primary">
                {{
                  scope.row.tcqltt &&
                  scope.row.tcqltt.lich_su &&
                  scope.row.tcqltt.lich_su.length > 0
                    ? scope.row.tcqltt.lich_su[
                        scope.row.tcqltt.lich_su.length - 1
                      ].ly_do
                    : "" | replaceText
                }}
              </p>
            </template>
          </el-table-column>
          <el-table-column
            prop="thoi_diem_phan_hoi"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.rf_time"
            :formatter="fn_formatterDatetime"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <p class="m-0 p-0">
                {{ fn_formatterDatetimeList(scope.row.thoi_diem_phan_hoi) }}
              </p>
              <p class="m-0 p-0 text-primary">
                {{
                  scope.row.tcqltt &&
                  scope.row.tcqltt.lich_su &&
                  scope.row.tcqltt.lich_su.length > 0
                    ? fn_formatterDatetimeList(
                        scope.row.tcqltt.lich_su[
                          scope.row.tcqltt.lich_su.length - 1
                        ].thoi_diem
                      )
                    : ""
                }}
              </p>
            </template>
          </el-table-column>
          <el-table-column
            prop="ten_trang_thai"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.rf_status"
            width="170"
            align="center"
          >
            <template slot-scope="scope">
              <p :class="`status status__${scope.row.trang_thai}`">
                {{ scope.row.ten_trang_thai }}
              </p>
              <p class="m-0 p-0 text-primary">
                {{ scope.row.ten_trang_thai_duyet }}
              </p>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="ten_trang_thai_duyet"
            :sortable="mData.tableRules.allowSorting"
            label="Trạng thái"
            width="120"
            align="center"
            v-if="aRole('TCQLTT')"
          ></el-table-column>-->
          <el-table-column :label="aLang.c_action" align="center" width="150">
            <template slot-scope="scope">
              <!-- <el-dropdown
                trigger="click"
                class="mr-2"
                @command="fn_changeTrangThaiDuyet"
                v-if="aRole('TCQLTT')"
              >
                <el-button size="mini" v-b-tooltip.hover title="Chuyển trạng thái">
                  <i class="icon-refresh"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="item in mData.dataDefault.trangThaiTcqltt"
                    :key="item.code"
                    :command="fn_mergeTrangThai(scope.row, item.code)"
                  >{{item.text}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>-->
              <el-button
                size="mini"
                @click="fn_handle('updateTcqltt', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_changeStatus"
                :disabled="!scope.row.allowChange == true"
                v-if="aRole('TCQLTT')"
              >
                <i class="icon-refresh"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('updateTrangThai', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_changeStatus"
                :disabled="scope.row.trang_thai == 'forwarded_to_tcqltt'"
                v-if="!aRole('TCQLTT')"
              >
                <i class="icon-refresh"></i>
              </el-button>

              <!-- <el-dropdown
                trigger="click"
                class="mr-2"
                @command="fn_changeTrangThai"
                v-if="!aRole('TCQLTT')"
              >
                <el-button
                  size="mini"
                  v-b-tooltip.hover
                  title="Chuyển trạng thái"
                  :disabled="scope.row.trang_thai=='forwarded_to_tcqltt'&&!aRole('Admin')"
                >
                  <i class="icon-refresh"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="item in mData.dataDefault.listTrangThai"
                    :key="item.code"
                    :command="fn_mergeTrangThai(scope.row, item.code)"
                  >{{item.text}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->

              <el-button
                size="mini"
                @click="fn_handle('detail', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>
              <!-- <el-button
                size="mini"
                @click="fn_handle('update',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update"
                v-if="aRole('Officer,TourAgent')"
              >
                <i class="icon-pencil icons"></i>
              </el-button>-->
              <el-button
                :disabled="
                  aRole('Officer,TourAgent,SVHTT') &&
                  scope.row.trang_thai == 'forwarded_to_tcqltt'
                "
                size="mini"
                @click="fn_handle('delete', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete"
                v-if="aRole('Admin,Officer,TourAgent,SVHTT')"
              >
                <i class="icon-trash icons"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div v-if="mData.tableRules.allowSelect">
              {{ aLang.c_select }}: {{ mData.tableRules.recordSelected.length }}
            </div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
    <el-dialog
      :visible.sync="mData.dataDefault.dialog"
      :title="aLang.c_changeStatus + ' xử lý ' + phanHoiText"
    >
      <chuyen-trang-thai-xu-ly-phan-hoi
        :componentProps="mData.dataDefault.dataForDialog"
      ></chuyen-trang-thai-xu-ly-phan-hoi>
    </el-dialog>
    <el-dialog
      class="dialog-admin"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="mData.dataDefault.dialogAdmin"
      :title="aLang.c_changeStatus + ' xử lý ' + phanHoiText"
    >
      <chuyen-trang-thai-xu-ly-phan-hoi-admin
        :componentProps="mData.dataDefault.dataForDialog"
        :close="true"
      ></chuyen-trang-thai-xu-ly-phan-hoi-admin>
    </el-dialog>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";

// import ValidService from "../../../service/ValidService";
import PhanHoiModel from "./PhanHoiModel";
import PhanHoiApi from "../../../moduleApi/PhanHoiApi";
import NhomPhanHoiApi from "../../../moduleApi/NhomPhanHoiApi";
import CauHinhApi from "../../../moduleApi/CauHinhApi";
import KhachDuLichApi from "../../../moduleApi/KhachDuLichApi";
import HuongDanVienApi from "../../../moduleApi/HuongDanVienApi";
import TourApi from "../../../moduleApi/TourApi";
//import AccountApi from "../../../moduleApi/AccountApi";
import ProfileApi from "../../../moduleApi/ProfileApi";
import NguoiDungTcqlttApi from "../../../moduleApi/NguoiDungTcqlttApi";

import ChuyenTrangThaiXuLyPhanHoi from "../../../component/ChuyenTrangThaiXuLyPhanHoi";
import ChuyenTrangThaiXuLyPhanHoiAdmin from "@/component/ChuyenTrangThaiXuLyPhanHoiAdmin";
//import { now } from "moment";

export default {
  components: {
    ChuyenTrangThaiXuLyPhanHoi,
    ChuyenTrangThaiXuLyPhanHoiAdmin,
  },
  data() {
    return {
      nguoiGui: "",
      loai_nhom_phan_hoi: "",
      nhom_phan_hoi: "",
      trang_thai: "",
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "PhanHoi", //requied
        tableRules: MethodService.copyObject(PhanHoiModel.tableRules),
        dataDefault: {
          roles: DataService.roles,
          // listCongTyLuHanh: [],
          listTour: [],
          listKhachDuLich: [],
          listHuongDanVien: [],
          listNhomPhanHoi: [],
          listNhomPhanHoiTable: [],
          textFindNguoiXuLy: "",
          listFindNguoiXuLy: [],
          dataNguoiXuLy: [],
          listLoaiNhomPhanHoi: DataService.loaiNhomPhanHoi,
          textFindNguoiGui: "",
          listNguoiGui: [],
          listFindNguoiGui: [],
          itemNguoiGui: null,
          loai_nhom_phan_hoi: null,
          trangThai: MethodService.copyObject(PhanHoiModel.trangThai),
          listTrangThai: MethodService.copyObject(PhanHoiModel.trangThai),
          trangThaiTcqltt: PhanHoiModel.trangThaiTcqltt,
          nguoiXuLyTCQLTT: "",
          listTCQLTT: [],
          countPhanHois: 0,
          firstLoad: true,
          listDoiTuongPhanHoi: MethodService.copyObject(
            DataService.doiTuongPhanHoi
          ),
          dataForDialog: null,
          dialog: false,
          dialogAdmin: false,
          // tcqlttItem: MethodService.copyObject(PhanHoiModel.dataFormOther.tcqltt),
        },
      },
      phanHoiText: "phản ánh",
    };
  },

  filters: {
    replaceText: function (value) {
      if (!value) return "";
      // if (!MethodService.checkRole('TCQLTT')) {
      //   return value;
      // }
      return value.replaceAll(/phản hồi/gi, "phản ánh");
    },
  },
  methods: {
    querySearchLoaiNhomPhanHoi(queryString, cb) {
      if (queryString) {
        queryString = queryString.trim();
      }

      var results = queryString
        ? this.mData.dataDefault.listLoaiNhomPhanHoi.filter((item) =>
            item.text.toLowerCase().includes(queryString.toLowerCase())
          )
        : this.mData.dataDefault.listLoaiNhomPhanHoi;
      // call callback function to return suggestions
      cb(results);
      // call callback function to return suggestions
      cb(results);
    },
    handleSelectLoaiNhomPhanHoi(item) {
      this.mData.dataDefault.loai_nhom_phan_hoi = item.code;
      this.fn_selectData(this.mData.dataDefault.loai_nhom_phan_hoi);
      this.loai_nhom_phan_hoi = item.text;
      if (!this.loai_nhom_phan_hoi) {
        this.nhom_phan_hoi = "";
      }
    },
    //nhom phan hoi
    querySearchNhomPhanHoi(queryString, cb) {
      if (queryString == "") {
        this.fn_tableSearch();
      }
      if (queryString) {
        queryString = queryString.trim();
      }
      var results = queryString
        ? this.mData.dataDefault.listNhomPhanHoi.filter((item) =>
            item.ten.vi.toLowerCase().includes(queryString.toLowerCase())
          )
        : this.mData.dataDefault.listNhomPhanHoi;
      // call callback function to return suggestions
      cb(results);
      // call callback function to return suggestions
      cb(results);
    },
    handleSelectNhomPhanHoi(item) {
      if (!item) {
        this.mData.tableRules.dataSearch.value.nhom_phan_hoi = undefined;
        this.nhom_phan_hoi = undefined;
        this.fn_tableSearch();
        return;
      }
      if (item.id) {
        this.mData.tableRules.dataSearch.value.nhom_phan_hoi = item.id;
        if (item.ten) {
          let tenA = item.ten.vi
            .replaceAll("/n", "")
            .replaceAll(/\s+/g, " ")
            .trim();
          console.log("tenA", tenA);
          this.nhom_phan_hoi = tenA;
        }
        this.fn_tableSearch();
      }
    },
    //search
    async querySearchNguoiGui(queryString, cb) {
      queryString = queryString.trim();

      let suggestUser = await PhanHoiApi.suggestUser(queryString);
      if (suggestUser.result && suggestUser.result.length > 0) {
        this.mData.dataDefault.listFindNguoiGui = suggestUser.result;
      }
      var results = queryString
        ? this.mData.dataDefault.listFindNguoiGui.filter((item) =>
            item.ho_ten.toLowerCase().includes(queryString.toLowerCase())
          )
        : this.mData.dataDefault.listFindNguoiGui;

      // call callback function to return suggestions
      cb(results);
    },
    handleSelectNguoiGui(item) {
      this.mData.tableRules.dataSearch.value.nguoi_gui_id = item.nguoi_gui_id;
      this.nguoiGui = item.ho_ten;
    },
    //get list table
    async fn_initTable() {
      let currentUser = MethodService.getCurrentUser();
      let stringFilter = "";
      if (
        MethodService.checkRole("TCQLTT") &&
        !MethodService.checkRole("TCQLTTP") &&
        this.mData.dataDefault.firstLoad
      ) {
        if (
          this.mData.tableRules.filters.includes("tcqltt.nguoi_xu_ly_id:in:") ==
          false
        ) {
          stringFilter = "tcqltt.nguoi_xu_ly_id:in:" + currentUser.id;
          this.mData.dataDefault.dataNguoiXuLy.push(currentUser.id);
        }
        this.mData.dataDefault.firstLoad = false;
      }
      if (MethodService.checkRole("TCQLTT")) {
        let resNguoiXuLyApi = await NguoiDungTcqlttApi.list({
          limit: 1000,
        });
        if (resNguoiXuLyApi.result && resNguoiXuLyApi.result.length > 0) {
          let nguoiXuLyIds = [];
          resNguoiXuLyApi.result.forEach((nxl) => {
            nguoiXuLyIds.push(nxl.id);
          });
          let resProfile = await ProfileApi.list({
            limit: 1000,
            filters: `id:in:${nguoiXuLyIds.join(",")}`,
          });
          if (resProfile.result) {
            this.mData.dataDefault.listFindNguoiXuLy = resProfile.result;
          }
        }
      }

      let dataFilter = {
        filters: stringFilter.trim() + this.mData.tableRules.filters,
        fields:
          "id,nguoi_gui_id,province_id,thoi_diem_phan_hoi,nhom_phan_hoi,cong_ty_lu_hanh_id,diem_den_an_toan_id,doi_tuong_nhan,tour_id,noi_dung,file_dinh_kem,trang_thai,lich_su,tcqltt,loc",
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-" + this.mData.moduleName + "-list",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch(() => {});
      }

      let res = await PhanHoiApi.list(dataFilter);

      // get tour name, huong dan vien name
      //helper - new
      let resData = MethodService.checkDifferentObject(
        MethodService.copyObject(PhanHoiModel.dataForm),
        res.result
      );
      let tourIds = [];
      let nguoiGuiIds = [];
      let nguoiXuLyIds = [];

      tourIds = MethodService.findListItemDifferent(resData, "tour_id");
      nguoiGuiIds = MethodService.findListItemDifferent(
        resData,
        "nguoi_gui_id"
      );

      // lấy id nguoi xu ly
      let arrNguoiXuLy = [];
      resData.forEach((item) => {
        if (item.tcqltt && item.tcqltt.nguoi_xu_ly_id) {
          arrNguoiXuLy.push(item.tcqltt.nguoi_xu_ly_id);
        }
      });
      nguoiXuLyIds = MethodService.findListItemDifferent(arrNguoiXuLy);

      // end lấy id nguoi xu ly

      let reqTourApi = TourApi.list({
        limit: tourIds.length,
        filters: "id:in:" + tourIds.join(","),
      });
      let reqKhachDuLichApi = KhachDuLichApi.list({
        limit: nguoiGuiIds.length,
        filters: "id:in:" + nguoiGuiIds.join(","),
      });
      let reqHuongDanVienApi = HuongDanVienApi.list({
        limit: nguoiGuiIds.length,
        filters: "id:in:" + nguoiGuiIds.join(","),
      });

      let reqNguoiXuLyApi = ProfileApi.list({
        limit: nguoiXuLyIds.length,
        filters: "id:in:" + nguoiXuLyIds.join(","),
      });

      let resTourApi = await reqTourApi;
      let resKhachDuLichApi = await reqKhachDuLichApi;
      let resHuongDanVienApi = await reqHuongDanVienApi;
      let resNguoiXuLyApi = await reqNguoiXuLyApi;

      this.mData.dataDefault.listTour = resTourApi.result;
      this.mData.dataDefault.listKhachDuLich = resKhachDuLichApi.result;
      this.mData.dataDefault.listHuongDanVien = resHuongDanVienApi.result;
      this.mData.dataDefault.listNguoiXuLy = resNguoiXuLyApi.result;

      resData.forEach((item) => {
        let nguoiGuiKhachDL = this.mData.dataDefault.listKhachDuLich.find(
          (element) => {
            return element.id == item.nguoi_gui_id;
          }
        );
        if (nguoiGuiKhachDL) {
          if (
            nguoiGuiKhachDL.ho_ten &&
            nguoiGuiKhachDL.ho_ten.ho_ten &&
            nguoiGuiKhachDL.ho_ten.ho_ten.trim() != ""
          ) {
            item.ten_nguoi_gui = nguoiGuiKhachDL.ho_ten.ho_ten;
          }
          item.dien_thoai = nguoiGuiKhachDL.dien_thoai;
        } else {
          let nguoiGuiHDV = this.mData.dataDefault.listHuongDanVien.find(
            (element) => {
              return element.id == item.nguoi_gui_id;
            }
          );
          if (nguoiGuiHDV) {
            item.ten_nguoi_gui = nguoiGuiHDV.ho_ten.ho_ten;
            item.dien_thoai = nguoiGuiHDV.dien_thoai;
          }
        }

        let tenTour = this.mData.dataDefault.listTour.find((element) => {
          return element.id == item.tour_id;
        });
        if (tenTour) {
          item.ten_tour = tenTour.ten_tour;
        } else {
          item.ten_tour = "";
        }

        let tenTrangThai = this.mData.dataDefault.trangThai.find((element) => {
          return element.code == item.trang_thai;
        });
        if (tenTrangThai) {
          item.ten_trang_thai = tenTrangThai.text;
        } else {
          item.ten_trang_thai = "";
        }
        if (item.tcqltt && item.tcqltt.trang_thai) {
          let tenTrangThaiDuyet = this.mData.dataDefault.trangThaiTcqltt.find(
            (element) => {
              return element.code == item.tcqltt.trang_thai;
            }
          );
          if (tenTrangThaiDuyet) {
            item.ten_trang_thai_duyet = tenTrangThaiDuyet.text;
          } else {
            item.ten_trang_thai_duyet = "";
          }
        } else {
          item.ten_trang_thai_duyet = "";
        }

        if (this.aRole("TCQLTT")) {
          // debugger
          // let tenTrangThaiDuyet = this.mData.dataDefault.trangThaiTcqltt.find(
          //   element => {
          //     return element.code == item.tcqltt.trang_thai;
          //   }
          // );
          // if (tenTrangThaiDuyet) {
          //   item.ten_trang_thai_duyet = tenTrangThaiDuyet.text;
          // } else {
          //   item.ten_trang_thai_duyet = "";
          // }
          if (
            item.tcqltt &&
            item.tcqltt.nguoi_xu_ly_id &&
            currentUser.id == item.tcqltt.nguoi_xu_ly_id
          ) {
            item.allowChange = true;
          }
        }

        let tenNhomPhanHoi = this.mData.dataDefault.listNhomPhanHoiTable.find(
          (element) => {
            return element.id == item.nhom_phan_hoi;
          }
        );
        if (tenNhomPhanHoi) {
          item.loai = tenNhomPhanHoi.loai ? tenNhomPhanHoi.loai : "";
          item.ten_nhom_phan_hoi = tenNhomPhanHoi.ten.vi;
          item.allowSend = tenNhomPhanHoi.chuyen_tcqltt;
        } else {
          item.ten_nhom_phan_hoi = "Chưa có thông tin";
          item.allowSend = false;
        }

        if (item.tcqltt && item.tcqltt.nguoi_xu_ly_id) {
          let tenNXL = this.mData.dataDefault.listNguoiXuLy.find((element) => {
            return element.id == item.tcqltt.nguoi_xu_ly_id;
          });
          if (tenNXL) {
            item.tcqltt.ten_nguoi_xu_ly = tenNXL.ho_ten.ho_ten;
          } else {
            item.tcqltt.ten_nguoi_xu_ly = "";
          }
        }
      });

      this.mData.tableRules.data = resData;
      console.log("this.mData.tableRules.data", this.mData.tableRules.data);
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      }
    },

    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create",
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id },
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id },
        });
      }
      if (type == "updateTcqltt") {
        this.mData.dataDefault.dataForDialog = {
          id: row.id,
          mode: "updateTcqltt",
        };
        this.mData.dataDefault.dialog = true;
      }
      if (type == "updateTrangThai") {
        this.mData.dataDefault.dataForDialog = {
          id: row.id,
          mode: "updateTrangThai",
          allowSend: row.allowSend,
        };
        this.mData.dataDefault.dialogAdmin = true;
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
      if (type == "disable") {
        this.$confirm(LanguageService.lang.user_disableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_disable(row.id, true);
          })
          .catch(() => {});
      }
      if (type == "openDisable") {
        this.$confirm(LanguageService.lang.user_openDisableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_disable(row.id, false);
          })
          .catch(() => {});
      }
    },
    changeDataNhomPhanHoi(data) {
      const LOAI_LABELS = {
        kdl: "Khách du lịch",
        hdv: "Hướng dẫn viên",
        ddat: "Điểm đến",
      };

      return data
        .filter(({ loai }) => loai !== "trang_vang")
        .map((nhomPhanHoi) => {
          const label = LOAI_LABELS[nhomPhanHoi.loai] || "";
          if (nhomPhanHoi.ten && nhomPhanHoi.ten.vi) {
            nhomPhanHoi.ten.vi = `${label} - ${nhomPhanHoi.ten.vi}`;
          }
          return nhomPhanHoi;
        });
    },

    async fn_selectData(id) {
      if (id == "") {
        if (MethodService.checkRole("TCQLTT")) {
          let reqNhomPhanHoiApi = NhomPhanHoiApi.list({
            limit: 1000,
            filters: "chuyen_tcqltt=true",
          });
          let resNhomPhanHoiApi = await reqNhomPhanHoiApi;
          // this.mData.dataDefault.listNhomPhanHoi = resNhomPhanHoiApi.result;
          this.mData.dataDefault.listNhomPhanHoi = this.changeDataNhomPhanHoi(
            resNhomPhanHoiApi.result
          );
        } else {
          let reqNhomPhanHoiApi = NhomPhanHoiApi.list({ limit: 1000 });
          let resNhomPhanHoiApi = await reqNhomPhanHoiApi;
          // this.mData.dataDefault.listNhomPhanHoi = resNhomPhanHoiApi.result;
          this.mData.dataDefault.listNhomPhanHoi = this.changeDataNhomPhanHoi(
            resNhomPhanHoiApi.result
          );
        }

        this.mData.tableRules.dataSearch.value.nhom_phan_hoi = null;
        this.nhom_phan_hoi = "";
        this.fn_tableSearch();
      } else {
        if (MethodService.checkRole("TCQLTT")) {
          let reqNhomPhanHoiApi = NhomPhanHoiApi.list({
            limit: 10000,
            filters: "chuyen_tcqltt=true&loai:in:" + id,
          });

          let resNhomPhanHoiApi = await reqNhomPhanHoiApi;
          // this.mData.dataDefault.listNhomPhanHoi = resNhomPhanHoiApi.result;
          this.mData.dataDefault.listNhomPhanHoi = this.changeDataNhomPhanHoi(
            resNhomPhanHoiApi.result
          );
        } else {
          let reqNhomPhanHoiApi = NhomPhanHoiApi.list({
            limit: 10000,
            filters: "loai:in:" + id,
          });

          let resNhomPhanHoiApi = await reqNhomPhanHoiApi;
          // this.mData.dataDefault.listNhomPhanHoi = resNhomPhanHoiApi.result;
          this.mData.dataDefault.listNhomPhanHoi = this.changeDataNhomPhanHoi(
            resNhomPhanHoiApi.result
          );
        }

        this.mData.tableRules.dataSearch.value.nhom_phan_hoi = null;
        this.nhom_phan_hoi = "";
        this.fn_tableSearch();
      }
    },

    async fn_changeTrangThai(command) {
      let data = {
        id: command.id,
        trang_thai: command.trangThaiNew,
      };
      await PhanHoiApi.update(data);
      this.fn_initTable();
      this.$store.commit("fn_countPhanHoi");
    },

    async fn_changeTrangThaiDuyet(command) {
      let data = {
        id: command.id,
        "tcqltt.trang_thai": command.trangThaiNew,
      };
      await PhanHoiApi.update(data);
      this.fn_initTable();
    },

    //thêm trangThaiNew vào object
    fn_mergeTrangThai(row, status) {
      let object = MethodService.copyObject(row);
      object.trangThaiNew = status;
      return object;
    },

    //delete
    async fn_delete(id) {
      await PhanHoiApi.delete(id);
      this.fn_initTable();
    },

    //khóa tài khoản
    async fn_disable(id, disable) {
      await PhanHoiApi.disable(id, disable);
      this.fn_initTable();
    },

    //event table

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          // console.log(this.mData.tableRules.dataSearch);
          // debugger;
          let stringFilter = "";
          if (
            this.mData.dataDefault.dataNguoiXuLy &&
            this.mData.dataDefault.dataNguoiXuLy.length > 0
          ) {
            stringFilter = "tcqltt.nguoi_xu_ly_id:in:";
            this.mData.dataDefault.dataNguoiXuLy =
              MethodService.findListItemDifferent(
                this.mData.dataDefault.dataNguoiXuLy
              );
            this.mData.dataDefault.dataNguoiXuLy.map((nxl, index) => {
              if (index == this.mData.dataDefault.dataNguoiXuLy.length - 1) {
                stringFilter += nxl;
              } else {
                stringFilter += nxl + ",";
              }
            });
            stringFilter += "&";
          }

          this.mData.tableRules.filters =
            stringFilter +
            MethodService.filterTable(
              JSON.stringify(this.mData.tableRules.dataSearch)
            );

          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.replace({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query,
      });
    },

    fn_changeSelectedToSend(selectedValue) {
      if (selectedValue == true) {
        this.mData.dataDefault.countPhanHois++;
      } else {
        this.mData.dataDefault.countPhanHois--;
      }
    },

    async fn_SendTcqltt() {
      let resNguoiXuLyTCQLTT = await CauHinhApi.list({
        filters: "code:in:default_user_tcqltt_id",
      });
      if (
        !resNguoiXuLyTCQLTT ||
        !resNguoiXuLyTCQLTT.result ||
        resNguoiXuLyTCQLTT.result.length === 0
      ) {
        return;
      }
      this.mData.dataDefault.nguoiXuLyTCQLTT =
        resNguoiXuLyTCQLTT.result[0].value;

      const itemsToSend = this.mData.tableRules.data.filter(
        (i) => i.selectedToSend === true
      );
      if (itemsToSend.length === 0) {
        return;
      }

      let currentUser = MethodService.getCurrentUser();

      try {
        for (const item of itemsToSend) {
          const lichSuItem = MethodService.copyObject(
            PhanHoiModel.dataFormOther.lich_su
          );
          lichSuItem.tu = currentUser.id;
          lichSuItem.den = this.mData.dataDefault.nguoiXuLyTCQLTT;
          lichSuItem.ly_do =
            "Hệ thống chuyển phản hồi tới tổng cục quản lý thị trường";
          lichSuItem.thoi_diem = new Date();
          lichSuItem.trang_thai = "new";

          const tcqlttItem = MethodService.copyObject(
            PhanHoiModel.dataFormOther.tcqltt
          );
          tcqlttItem.nguoi_xu_ly_id = this.mData.dataDefault.nguoiXuLyTCQLTT;
          tcqlttItem.trang_thai = "new";

          if (
            item.tcqltt &&
            item.tcqltt.lich_su &&
            item.tcqltt.lich_su.length > 0
          ) {
            tcqlttItem.lich_su = [...item.tcqltt.lich_su];
          }

          tcqlttItem.lich_su.push(lichSuItem);

          const data = {
            id: item.id,
            trang_thai: "forwarded_to_tcqltt",
            tcqltt: tcqlttItem,
          };

          // BE tự gửi mail sau khi update thành công, FE không gọi sendEmail nữa (task 60473)
          await PhanHoiApi.updateSend(data);

          item.selectedToSend = false;
          this.fn_changeSelectedToSend(item.selectedToSend);
        }

        this.fn_initTable();
        this.$store.commit("fn_countPhanHoi");
      } catch (error) {
        console.error(error);
      }
    },

    //
    async fn_findNguoiGui() {
      this.mData.dataDefault.textFindNguoiGui =
        this.mData.dataDefault.textFindNguoiGui.trim();
      if (!this.mData.dataDefault.textFindNguoiGui) {
        return;
      }
      this.mData.dataDefault.listFindNguoiGui = [];
      // let resKhachDL = await KhachDuLichApi.list({
      //   limit: 1000,
      //   filters: `ho_ten.ho_ten:regex_i:${this.mData.dataDefault.textFindNguoiGui}`
      // });
      // let resHDV = await HuongDanVienApi.list({
      //   limit: 1000,
      //   filters: `ho_ten.ho_ten:regex_i:${this.mData.dataDefault.textFindNguoiGui}`
      // });
      // if (resKhachDL.result && resKhachDL.result.length > 0) {
      //   this.mData.dataDefault.listFindNguoiGui = this.mData.dataDefault.listFindNguoiGui.concat(
      //     resKhachDL.result
      //   );
      // }
      // if (resHDV.result && resHDV.result.length > 0) {
      //   this.mData.dataDefault.listFindNguoiGui = this.mData.dataDefault.listFindNguoiGui.concat(
      //     resHDV.result
      //   );
      // }
      let suggestUser = await PhanHoiApi.suggestUser(
        this.mData.dataDefault.textFindNguoiGui.trim()
      );
      if (suggestUser.result && suggestUser.result.length > 0) {
        this.mData.dataDefault.listFindNguoiGui = suggestUser.result;
      }
    },

    async fn_remoteGetListNguoiGui(query) {
      this.mData.dataDefault.textFindNguoiGui = query.trim();
    },
    async fn_enterFindNguoiGui() {
      if (!this.mData.dataDefault.textFindNguoiGui) {
        return;
      }
      let resKhachDuLichApi = await KhachDuLichApi.list({
        limit: 1000,
        filters: `ho_ten.ho_ten:regex_i:${this.mData.dataDefault.textFindNguoiGui}`,
      });
      this.mData.dataDefault.listNguoiGui = resKhachDuLichApi.result;
    },

    async fn_findNguoiXuLy() {
      if (!this.mData.dataDefault.textFindNguoiXuLy) {
        return;
      }
      let resNXL = await ProfileApi.list({
        limit: 1000,
        filters: `ho_ten.ho_ten:regex_i:${this.mData.dataDefault.textFindNguoiXuLy}`,
      });
      if (resNXL.result && resNXL.result.length > 0) {
        this.mData.dataDefault.listFindNguoiXuLy = resNXL.result.filter(
          (nxl) => {
            return this.mData.dataDefault.listTCQLTT.includes(nxl.id);
          }
        );
      } else {
        this.mData.dataDefault.listFindNguoiXuLy = [];
      }
    },

    async fn_remoteGetNguoiXuLy(query) {
      this.mData.dataDefault.textFindNguoiXuLy = query;
    },
    //
    fn_formatterDate(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_formatterDatetimeList(cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_formatterRoles(row, column, cellValue) {
      var roles = "";
      cellValue.forEach((item) => {
        for (let i = 0; i < this.mData.dataDefault.roles.length; i++) {
          if (item == this.mData.dataDefault.roles[i].value) {
            item = this.mData.dataDefault.roles[i].label;
            roles += item + " ,";
          }
        }
      });
      roles = roles.slice(0, -1);
      return roles;
    },

    async fn_initDataDefault() {
      if (MethodService.checkRole("TCQLTT")) {
        let reqNhomPhanHoiApi = NhomPhanHoiApi.list({
          limit: 1000,
          filters: "chuyen_tcqltt=true",
        });
        let resNhomPhanHoiApi = await reqNhomPhanHoiApi;
        this.mData.dataDefault.listNhomPhanHoi = this.changeDataNhomPhanHoi(
          resNhomPhanHoiApi.result
        );
        this.mData.dataDefault.listNhomPhanHoiTable = resNhomPhanHoiApi.result;
        let resTCQLTT = await NguoiDungTcqlttApi.list({ limit: 1000 });
        this.mData.dataDefault.listTCQLTT = [];
        if (resTCQLTT.result && resTCQLTT.result.length > 0) {
          for (let item of resTCQLTT.result) {
            this.mData.dataDefault.listTCQLTT.push(item.id);
          }
        }
      } else {
        let reqNhomPhanHoiApi = NhomPhanHoiApi.list({ limit: 1000 });
        let resNhomPhanHoiApi = await reqNhomPhanHoiApi;
        // this.mData.dataDefault.listNhomPhanHoi = resNhomPhanHoiApi.result;
        this.mData.dataDefault.listNhomPhanHoi = this.changeDataNhomPhanHoi(
          resNhomPhanHoiApi.result
        );
        this.mData.dataDefault.listNhomPhanHoiTable = resNhomPhanHoiApi.result;
      }

      this.mData.dataDefault.listTrangThai.pop();

      // if (MethodService.checkRole("VNATAdmin")) {
      //   this.mData.dataDefault.loai_nhom_phan_hoi="kdl";
      //   this.fn_selectData(this.mData.dataDefault.loai_nhom_phan_hoi)
      // }

      // let reqCongTyLuHanhApi = CongTyLuHanhApi.list({ limit: 10000 });
      // let resCongTyLuHanhApi = await reqCongTyLuHanhApi;
      // this.mData.dataDefault.listCongTyLuHanh = resCongTyLuHanhApi.result;
    },

    async fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        let cacheArray = this.mData.tableRules.filters.split("&");
        for (let item of cacheArray) {
          if (item.includes("tcqltt.nguoi_xu_ly_id:in:")) {
            let string = item.replace("tcqltt.nguoi_xu_ly_id:in:", "");
            this.mData.dataDefault.dataNguoiXuLy = string.split(",");
            let resNguoiGui = await ProfileApi.list({
              limit: 1000,
              filters: `id:in:${string}`,
            });
            this.mData.dataDefault.listFindNguoiXuLy = resNguoiGui.result;
            let index = cacheArray.indexOf(item);
            cacheArray.splice(index, 1);
          }
        }
        let stringFilter = cacheArray.join("&");

        // string to object
        if (stringFilter.trim() != "") {
          this.mData.tableRules.dataSearch.value =
            MethodService.stringToObject(stringFilter);
          let reqNhomPhanHoiApi = await NhomPhanHoiApi.list({
            limit: 10000,
          });
          if (reqNhomPhanHoiApi.result) {
            let nhom_phan_hoi = reqNhomPhanHoiApi.result.find(
              (item) =>
                item.id == this.mData.tableRules.dataSearch.value.nhom_phan_hoi
            );
            if (nhom_phan_hoi) {
              this.nhom_phan_hoi = nhom_phan_hoi.ten.vi;
            }
          }
        }
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
      if (this.mData.tableRules.dataSearch.value.nguoi_gui_id) {
        let resKhachDL = await KhachDuLichApi.findById(
          this.mData.tableRules.dataSearch.value.nguoi_gui_id
        );

        if (resKhachDL.result) {
          this.mData.dataDefault.listFindNguoiGui.push(resKhachDL.result);
          this.nguoiGui = resKhachDL.result.ho_ten.ho_ten;
        } else {
          let resHDV = await HuongDanVienApi.findById(
            this.mData.tableRules.dataSearch.value.nguoi_gui_id
          );
          if (resHDV.result) {
            this.mData.dataDefault.listFindNguoiGui.push(resHDV.result);
            this.nguoiGui = resHDV.result.ho_ten.ho_ten;
          }
        }
      }
    },
    fn_delay(callback, ms) {
      let timer = 0;
      return function () {
        let context = this,
          args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          callback.apply(context, args);
        }, ms || 0);
      };
    },
  },

  //run after render view
  created() {
    this.fn_initDataDefault();
    this.fn_hashUrl();
  },
  mounted() {
    this.fn_initTable();
  },
};
</script>
<style lang="scss">
.el-autocomplete.inline-input {
  width: 100%;
}
// .dialog-admin .el-dialog{
//   margin-top: 5vh !important;
// }
.dialog-admin .el-dialog__body {
  max-height: 750px;
  overflow: auto;
}
.dialog-admin .el-dialog__body .card {
  margin-bottom: 0;
}
.doi-tuong {
  color: #eaeaea;
  padding: 1px 10px;
  border-radius: 10px;
  &__DDAT {
    background-color: #529b2e;
  }
  &__CQQL {
    background-color: #444892;
  }
  &__DNLH {
    background-color: #c8557c;
  }
}
.status {
  padding: 1px 10px;
  border-radius: 10px;
  margin: 0;
  line-height: 18px;
  &__processed {
    background-color: rgba(82, 155, 46, 0.2);
    color: #529b2e;
  }
  &__processing {
    background-color: rgba(51, 204, 204, 0.2);
    color: rgb(36, 180, 180);
  }
  &__new {
    background-color: rgba(255, 128, 0, 0.2);
    color: #ff8000;
  }
  &__forwarded_to_tcqltt {
    background-color: rgba(200, 85, 123, 0.2);
    color: #c8557c;
  }
}
@media (max-width: 1360px) {
  .dialog-admin .el-dialog {
    margin-top: 5vh !important;
  }
  .dialog-admin .el-dialog__body {
    max-height: 600px;
    overflow: auto;
  }
  .dialog-admin .el-dialog__body .card .card-body .el-form .el-form-item {
    margin-bottom: 10px;
  }
}
.el-autocomplete-suggestion li {
  word-break: break-word;
  white-space: unset;
}
</style>
